module.exports = __webpack_public_path__ + "img/p2-1-1.4a47f5f2.png";